import React, { useState } from 'react';
import { Breadcrumbs, ContentLayout } from 'components/Layout';
import { Head } from 'components/Head';

import { useQuery } from 'react-query';
import { useNotifications } from '../api/getNotifications';
import { SendNotificationNavigation } from '../components/SendNotificationNavigation';
import { Notification } from '../components/Notification';

const categories = ['Transaction', 'Primary', 'System', 'Updates'];
const statuses = ['All', 'Seen', 'Unseen'];

export const Notifications = () => {
  const [activeCategory, setActiveCategory] = useState('Transaction');
  const [activeStatus, setActiveStatus] = useState('All');
  const [pageNumber, setPageNumber] = useState(1);

  const filter = activeStatus.toLowerCase(); // all, seen, unseen
  const type = activeCategory.toLowerCase(); // transaction, primary, etc.

  const { data, isLoading, isError } = useQuery(
    ['notifications', filter, type],
    () => useNotifications({ filter, type, pageNumber }).queryFn(),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );

  const notifications = data?.notifications || [];

  const defaultNotification = {
    id: 'default-welcome',
    category: 'Welcome',
    title: 'Welcome to your new notification center',
    message:
      'The notification system notifies you of important events such as replies, mentions, updates etc.',
    createdAt: '2025-05-13T23:00:00Z',
    status: 'unseen',
    type: 'system',
  };

  return (
    <ContentLayout
      title={
        <h2 className="text-2xl font-semibold text-neutral-100">
          Notifications
        </h2>
      }
      breadcrumbs={<Breadcrumbs />}
      end={<SendNotificationNavigation />}
    >
      <Head title="Notifications" />

      <div className="flex flex-row items-center justify-between space-x-2 mb-4">
        {/* Categories */}
        <div className="bg-white/10 rounded-xl w-fit p-1 flex flex-wrap gap-1">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-1 text-sm rounded-lg border backdrop-blur-lg ${
                activeCategory === cat
                  ? 'bg-white/20 border-white/30 text-white'
                  : 'bg-white/5 border-white/10 text-white/60 hover:bg-white/10'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Statuses */}
        <div className="bg-white/10 rounded-xl w-fit p-1 flex flex-wrap gap-1">
          {statuses.map((status) => (
            <button
              key={status}
              onClick={() => setActiveStatus(status)}
              className={`px-4 py-1 text-sm rounded-lg border backdrop-blur-lg ${
                activeStatus === status
                  ? 'bg-white/20 border-white/30 text-white'
                  : 'bg-white/5 border-white/10 text-white/60 hover:bg-white/10'
              }`}
            >
              {status}
            </button>
          ))}
        </div>
      </div>


      {/* Notifications List */}
      <div className="space-y-4">
        {isLoading &&
          Array.from({ length: 3 }).map((_, index) => (
            <div
              key={index}
              className="p-4 rounded-2xl bg-white/5 animate-pulse backdrop-blur-md"
            >
              <div className="flex justify-between items-start">
                <div className="flex items-center gap-3">
                  <div className="p-2 rounded-full bg-white/10 w-10 h-10" />
                  <div className="space-y-2">
                    <div className="w-52 h-3 bg-white/20 rounded" />
                    <div className="w-40 h-2 bg-white/10 rounded" />
                    <div className="w-32 h-2 bg-white/10 rounded" />
                  </div>
                </div>
                <div className="w-16 h-4 bg-white/10 rounded" />
              </div>
            </div>
          ))}

        {isError && (
          <p className="text-white/50 text-sm text-center py-10">
            Failed to load notifications. Please try again later.
          </p>
        )}

        {!isLoading &&
          [...notifications, defaultNotification].map((note) => (
            <Notification note={note} />
          ))}

        {!isLoading && notifications.length === 0 && <></>}
      </div>
    </ContentLayout>
  );
};
